import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import vueScrollTo from "vue-scrollto/vue-scrollto";
import VeeValidate from "vee-validate";
import "nprogress/nprogress.css";
import "../public/css/style.css";
import "../public/css/mxd.css";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "sweetalert2/dist/sweetalert2.min.css";
import WaveSurferVue from "wavesurfer.js-vue";
import ProgressBar from "vuejs-progress-bar";
import "normalize.css";
import 'bootstrap-icons/font/bootstrap-icons.css'

import dotenv from "dotenv";
dotenv.config();
const swlOptions = {
  confirmButtonColor: "#41b882",
  cancelButtonColor: "#ff7674",
  background: "#ffffff",
  heightAuto: "false",
  padding: "1.25rem",
  color: "#545454",
  timerProgressBar: "true",
  buttonsStyling: "true",
};

Vue.use(VeeValidate, {
  events: 'change|blur'
})
Vue.use(VueSweetalert2, swlOptions);
Vue.use(BootstrapVue);
Vue.use(WaveSurferVue);
Vue.use(ProgressBar);
Vue.use(vueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

import Axios from "axios";

Vue.prototype.$http = Axios;

const requireComponent = require.context(
  "./components",
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, "$1"))
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});

const dictionary = {
  en: {
    attributes: {
      username: 'Email Address'
    },
    custom: {
      confirmPassword: {
        required: () => 'Passwords must match!',
        confirmed: () => 'Passwords must match!'
      }
    }
  },
}

VeeValidate.Validator.localize(
  dictionary
)

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
